import ReceivedDocumentForm from "../components/received-document/ReceivedDocumentForm";

const ReceivedDocumentReadPage = () => {
  return <ReceivedDocumentForm readonly={true} />;
};

export default ReceivedDocumentReadPage;
